import "../../../FhMultiselect.css";
import { useSlots, ref, toRef, computed, provide, reactive, watch, openBlock, createElementBlock, unref, renderSlot, createVNode, withCtx, createSlots, mergeProps, createElementVNode, withModifiers, Fragment, createBlock, createTextVNode, createCommentVNode, renderList, toDisplayString, nextTick } from "vue";
import FhCheckboxInput from "../FhCheckboxInput/FhCheckboxInput.mjs";
import _sfc_main$1 from "../../Dropdowns/FhDropdownMultiSelectItem/FhDropdownMultiSelectItem.mjs";
import FhDropdownBaseItem from "../../Dropdowns/FhDropdownBaseItem/FhDropdownBaseItem.mjs";
import FhDropdownSection from "../../Dropdowns/FhDropdownSection/FhDropdownSection.mjs";
import FhInputContainer from "../FhInputContainer/FhInputContainer.mjs";
import FhInputField from "../FhInputField/FhInputField.mjs";
import { F as FhOverlay, f as flip, o as offset, s as size } from "../../../FhOverlay-Cm2BKH3f.js";
import FhTag from "../../FhTag/FhTag.mjs";
import FhValidationMessage from "../FhValidationMessage/FhValidationMessage.mjs";
import useDropdownNavigation from "../../Dropdowns/composables/useDropdownNavigation.mjs";
import useIsFieldRequired from "../composables/useIsFieldRequired.mjs";
import useFormField from "../composables/useFormField.mjs";
import { InputFieldContextKey } from "../Symbols.mjs";
import { generateUniqueId } from "../../utils.mjs";
import chevronDown from "../../../icons/chevronDown.mjs";
import { SIZES_ENUMS } from "../FhInputContainer/constants.mjs";
import { _ as _export_sfc } from "../../../_plugin-vue_export-helper-1tPrXgE0.js";
const _hoisted_1 = { class: "fh-multiselect-wrap" };
const _hoisted_2 = { class: "fh-multiselect-tags" };
const _sfc_main = /* @__PURE__ */ Object.assign({
  inheritAttrs: false
}, {
  __name: "FhMultiselect",
  props: {
    name: {
      type: String,
      default: ""
    },
    modelValue: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: ""
    },
    options: {
      type: Array,
      default: () => []
    },
    validators: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    prefixIcon: {
      type: String,
      default: ""
    },
    suffixIcon: {
      type: String,
      default: ""
    },
    selectAll: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: SIZES_ENUMS.SM,
      validator: (value) => Object.values(SIZES_ENUMS).includes(value)
    }
  },
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const slots = useSlots();
    const emit = __emit;
    const overlayRef = ref(null);
    const inputRef = ref(null);
    const dropdownListRef = ref(null);
    const inputQuery = ref("");
    const inputFocused = ref(false);
    const uniqueId = generateUniqueId();
    const componentId = `fh-input--${uniqueId}`;
    const validationId = `fh-validation--${uniqueId}`;
    const dropdownListId = `fh-dropdown-list--${uniqueId}`;
    const floatingOptions = {
      middleware: [
        flip(),
        offset(4),
        size({
          apply({ rects, elements }) {
            Object.assign(elements.floating.style, {
              width: `${rects.reference.width}px`
            });
          }
        })
      ],
      placement: "bottom-start"
    };
    const {
      value: formSystemValue,
      withinForm,
      meta,
      setValue: setFormSystemValue,
      errorMessage,
      handleBlur: handleFormSystemBlur
    } = useFormField(props.name, props.modelValue, {
      validators: toRef(props, "validators"),
      disabled: toRef(props, "disabled")
    });
    if (!Array.isArray(formSystemValue.value)) {
      setFormSystemValue([]);
    }
    const required = useIsFieldRequired();
    const {
      activeIndex: highlightedIndex,
      resetActiveIndex,
      handleInvokerKeydown,
      scrollToItem
    } = useDropdownNavigation(overlayRef, dropdownListRef, {
      includeSelectAll: props.selectAll
    });
    const computedInvalid = computed(() => {
      return errorMessage.value && meta.touched;
    });
    const computedFilteredOptions = computed(() => {
      if (!inputQuery.value) {
        return props.options;
      }
      return props.options.filter((option) => {
        const query = typeof inputQuery.value === "string" ? inputQuery.value.toLowerCase() : "";
        return option.label.toLowerCase().includes(query);
      });
    });
    const tagLabel = (tag) => {
      var _a;
      return (_a = props.options.find((option) => option.value === tag)) == null ? void 0 : _a.label;
    };
    const computedSelectAll = computed(() => {
      const selectedValues = formSystemValue.value || [];
      const selectedCount = selectedValues.length;
      const totalCount = props.options.length;
      return selectedCount === totalCount && totalCount > 0;
    });
    const computedIndeterminate = computed(() => {
      const selectedValues = formSystemValue.value || [];
      const selectedCount = selectedValues.length;
      const totalCount = props.options.length;
      return selectedCount > 0 && selectedCount < totalCount;
    });
    const computedAriaExpanded = computed(() => {
      var _a;
      return ((_a = overlayRef.value) == null ? void 0 : _a.isOpen) || false;
    });
    const openList = () => {
      if (!overlayRef.value.isOpen) {
        resetActiveIndex();
        overlayRef.value.open();
        nextTick(() => scrollToItem());
      }
    };
    const closeList = () => {
      if (overlayRef.value.isOpen) {
        overlayRef.value.close();
      }
    };
    const setValue = (values = []) => {
      setFormSystemValue(values);
      if (!withinForm) {
        emit("update:modelValue", values);
      }
    };
    const handleModelValueUpdate = (newValue) => {
      setValue(newValue);
    };
    const handleSelectAllToggle = () => {
      if (computedSelectAll.value) {
        setValue([]);
      } else {
        setValue(props.options.map((option) => option.value));
      }
    };
    const handleInputFocus = () => {
      inputFocused.value = true;
      openList();
    };
    const handleInputBlur = (event) => {
      var _a;
      inputFocused.value = false;
      const isClickInsideDropdown = (_a = dropdownListRef.value) == null ? void 0 : _a.contains(
        event.relatedTarget
      );
      if (!isClickInsideDropdown) {
        closeList();
      }
      inputQuery.value = "";
      handleFormSystemBlur(event);
    };
    const handleInputType = (event) => {
      inputQuery.value = event.target.value;
      openList();
    };
    const handleKeydownOnList = (event) => {
      if (event.key === "Escape") {
        closeList();
      }
    };
    const removeTag = (tagToRemove) => {
      const selectedValues = formSystemValue.value || [];
      const index = selectedValues.indexOf(tagToRemove);
      if (index !== -1) {
        selectedValues.splice(index, 1);
        setValue([...selectedValues]);
      }
    };
    const computeHighlightedIndex = (index) => {
      return props.selectAll && !inputQuery.value ? index + 1 : index;
    };
    provide(
      InputFieldContextKey,
      reactive({
        disabled: toRef(props, "disabled"),
        id: componentId,
        focused: inputFocused,
        valid: toRef(() => !computedInvalid.value)
      })
    );
    watch(
      formSystemValue,
      (newVal) => {
        if (!withinForm) {
          emit("update:modelValue", newVal);
        }
      },
      { deep: true }
    );
    if (!withinForm) {
      watch(
        () => props.modelValue,
        (newValue) => {
          if (newValue !== formSystemValue.value) {
            setFormSystemValue(newValue);
          }
        },
        { immediate: true }
      );
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [
        unref(slots).label ? renderSlot(_ctx.$slots, "label", { key: 0 }, void 0, true) : renderSlot(_ctx.$slots, "default", { key: 1 }, void 0, true),
        createVNode(FhOverlay, {
          role: "listbox",
          "close-on-click-outside": "",
          ref_key: "overlayRef",
          ref: overlayRef,
          anchor: "invoker",
          "floating-options": floatingOptions,
          useCloseDelay: false
        }, {
          invoker: withCtx(() => [
            createVNode(FhInputContainer, {
              decoratorIcon: unref(chevronDown),
              disabled: props.disabled,
              size: props.size,
              prefixIcon: props.prefixIcon,
              suffixIcon: props.suffixIcon
            }, createSlots({
              default: withCtx(() => [
                createVNode(FhInputField, mergeProps({
                  ref_key: "inputRef",
                  ref: inputRef,
                  role: "combobox",
                  autocomplete: "off",
                  value: inputQuery.value,
                  name: props.name,
                  id: componentId,
                  disabled: props.disabled,
                  placeholder: props.placeholder,
                  "aria-required": unref(required),
                  "aria-invalid": computedInvalid.value,
                  "aria-errormessage": computedInvalid.value && validationId,
                  "aria-expanded": computedAriaExpanded.value,
                  "aria-controls": dropdownListRef.value ? dropdownListId : void 0,
                  "aria-haspopup": true
                }, _ctx.$attrs, {
                  onClick: openList,
                  onFocus: handleInputFocus,
                  onInput: handleInputType,
                  onKeydown: unref(handleInvokerKeydown),
                  onBlur: handleInputBlur
                }), null, 16, ["value", "name", "disabled", "placeholder", "aria-required", "aria-invalid", "aria-errormessage", "aria-expanded", "aria-controls", "onKeydown"])
              ]),
              _: 2
            }, [
              _ctx.$slots.prefix ? {
                name: "prefix",
                fn: withCtx(() => [
                  renderSlot(_ctx.$slots, "prefix", {}, void 0, true)
                ]),
                key: "0"
              } : void 0,
              _ctx.$slots.suffix ? {
                name: "suffix",
                fn: withCtx(() => [
                  renderSlot(_ctx.$slots, "suffix", {}, void 0, true)
                ]),
                key: "1"
              } : void 0,
              _ctx.$slots.action ? {
                name: "action",
                fn: withCtx(() => [
                  renderSlot(_ctx.$slots, "action", {}, void 0, true)
                ]),
                key: "2"
              } : void 0
            ]), 1032, ["decoratorIcon", "disabled", "size", "prefixIcon", "suffixIcon"])
          ]),
          default: withCtx(() => [
            createElementVNode("ul", {
              class: "fh-multiselect-list",
              ref_key: "dropdownListRef",
              ref: dropdownListRef,
              onKeydown: handleKeydownOnList,
              onMousedown: _cache[0] || (_cache[0] = withModifiers(() => {
              }, ["prevent"]))
            }, [
              createVNode(FhDropdownSection, {
                modelValue: unref(formSystemValue),
                name: props.name,
                type: "multi-select",
                "onUpdate:modelValue": handleModelValueUpdate
              }, {
                default: withCtx(() => [
                  computedFilteredOptions.value.length ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                    props.selectAll && !inputQuery.value ? (openBlock(), createBlock(FhDropdownBaseItem, mergeProps({
                      key: 0,
                      onClick: handleSelectAllToggle,
                      role: "option",
                      class: "fh-multiselect-select-all",
                      tabindex: "-1"
                    }, {
                      highlighted: unref(highlightedIndex) === 0 ? "" : void 0
                    }), {
                      input: withCtx(() => [
                        createVNode(FhCheckboxInput, {
                          checked: computedSelectAll.value,
                          indeterminate: computedIndeterminate.value,
                          valid: ""
                        }, null, 8, ["checked", "indeterminate"])
                      ]),
                      default: withCtx(() => [
                        createTextVNode(" Select all ")
                      ]),
                      _: 1
                    }, 16)) : createCommentVNode("", true),
                    (openBlock(true), createElementBlock(Fragment, null, renderList(computedFilteredOptions.value, (option, index) => {
                      return openBlock(), createBlock(_sfc_main$1, mergeProps({
                        key: option.value,
                        value: option.value,
                        disabled: option.disabled,
                        "aria-selected": unref(formSystemValue).includes(option.value),
                        role: "option",
                        tabindex: "-1",
                        ref_for: true
                      }, {
                        highlighted: computeHighlightedIndex(index) === unref(highlightedIndex) ? "" : void 0
                      }), {
                        default: withCtx(() => [
                          createTextVNode(toDisplayString(option.label), 1)
                        ]),
                        _: 2
                      }, 1040, ["value", "disabled", "aria-selected"]);
                    }), 128))
                  ], 64)) : (openBlock(), createBlock(FhDropdownBaseItem, {
                    key: 1,
                    inert: ""
                  }, {
                    default: withCtx(() => [
                      createTextVNode(" No results found ")
                    ]),
                    _: 1
                  }))
                ]),
                _: 1
              }, 8, ["modelValue", "name"])
            ], 544)
          ]),
          _: 3
        }, 512),
        createElementVNode("div", _hoisted_2, [
          (openBlock(true), createElementBlock(Fragment, null, renderList(unref(formSystemValue), (tag) => {
            return openBlock(), createBlock(FhTag, {
              key: tag,
              dismissible: !props.disabled,
              onDismiss: ($event) => removeTag(tag),
              tabindex: "-1"
            }, {
              default: withCtx(() => [
                createTextVNode(toDisplayString(tagLabel(tag)), 1)
              ]),
              _: 2
            }, 1032, ["dismissible", "onDismiss"]);
          }), 128))
        ]),
        computedInvalid.value ? (openBlock(), createBlock(FhValidationMessage, {
          key: 2,
          id: validationId
        }, {
          default: withCtx(() => [
            createTextVNode(toDisplayString(unref(errorMessage)), 1)
          ]),
          _: 1
        })) : createCommentVNode("", true)
      ]);
    };
  }
});
const FhMultiselect = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-db4887ef"]]);
export {
  FhMultiselect as default
};
//# sourceMappingURL=FhMultiselect.mjs.map
